import { render, staticRenderFns } from "./Studies.vue?vue&type=template&id=312d6530&"
import script from "./Studies.vue?vue&type=script&lang=ts&"
export * from "./Studies.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports